import React from "react";

import type { AppRouter } from "@daytrip/fresh";
import { createTRPCReact } from "@trpc/react-query";

export const freshTrpcReact = createTRPCReact<AppRouter>({
    // using isolated context to enable multiple TRPC providers
    context: React.createContext(null) as any,
});
